import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInformation: {},
  isExistingUser: false,
  historicalCyclesValue: 'cycleTriggerTable'
};

const GeneralSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInformation = action.payload;
    },
    setIsExistingUserRx: (state, { payload }) => {
      state.isExistingUser = payload;
    },
    setHistoricalCyclesValue: (state, action) => {
      state.historicalCyclesValue = action.payload;
    },
  }
});

// Export actions for use in your components
export const { setUserInfo, setIsExistingUserRx, setHistoricalCyclesValue } = GeneralSlice.actions;

// Export the reducer to be included in the store
export default GeneralSlice.reducer;
